import {
  downloadCSV,
  generateTimestampedCsvFilename,
  toCsv,
} from "~/pages/Compliance/utils/csvExport";
import { toDbId } from "~/utils/graphql-helpers";
import { InvestmentEntitiesGraphqlDataSource } from "./investmentEntitiesGraphqlDataSource";
import type { RowItem } from "./types";
import type { ColumnState, GridApi, SortModelItem } from "ag-grid-community";

export { downloadCSV };

export const generateExportFilename = (): string => generateTimestampedCsvFilename("entities");

export const generateCSVContent = (rows: RowItem[]): string =>
  toCsv(
    [
      "Arena ID",
      "Arena name",
      "Entity ID",
      "Entity",
      "Legacy KYC enabled",
      "Compliance program",
      "Compliance program enabled",
    ],
    rows.map((row) => [
      row.arenaId,
      row.arenaName,
      toDbId(row.id),
      row.name,
      row.isInvestorDiligenceEnabled,
      row.complianceProgram,
      row.complianceEnabled,
    ]),
  );

export const exportAllFilteredRows = async (
  gridApi: GridApi,
  dataSource: InvestmentEntitiesGraphqlDataSource,
): Promise<void> => {
  const filterModel = gridApi.getFilterModel();
  const columnState = gridApi.getColumnState();
  const sortModel: SortModelItem[] = columnState
    .filter((col: ColumnState) => col.sort !== null)
    .map((col: ColumnState) => ({
      colId: col.colId,
      sort: col.sort as "asc" | "desc",
    }));

  const allRows: RowItem[] = await dataSource.getAllFilteredRows(filterModel, sortModel);
  const csvContent = generateCSVContent(allRows);
  const filename = generateExportFilename();
  downloadCSV(csvContent, filename);
};
